import React from 'react';
import { Table, Thead, Tbody, Tr, Th, Td, SortIconsWrapper, HeaderContentWrapper, HeaderCenterContent, HeaderText} from './TableStyle';
import {SortHeaderIcon, SearchHeaderIcon } from './TableIcons';
import { DEFAULT_TABLE_COLOR } from '../../GlobalStyles';

interface Column {
  displayName: string;
  key: string;
  type?: string;
  width?: number | string;
  headerRender?: () => React.ReactNode; // some headers have a custom icon
  sortable?: boolean; // shows the sort icon in the header for the column
  searchable?: boolean; // shows the search icon in the header for the column
}

interface AppTableProps {
  columns: Column[]; // Define the columns for the table
  children: React.ReactNode; //  Children to render inside the table body
  onSort?: (key: string, direction: 'asc' | 'desc') => void; // (Optional) Function to handle sorting
  sortConfig?: { key: string; direction: 'asc' | 'desc' } | null; // (Optional) sort state (key, direction)
  onSearch?: (key: string) => void; // (Optional) Function to handle searching when a search icon is clicked
  showSortIcons?: boolean; // Whether to show sort icons
  color?: string; //controls header and cell border color
  searchColumn?: string | null;
}

const AppTable: React.FC<AppTableProps & { narrow?: boolean }> = ({
  columns, 
  children, 
  onSort, 
  sortConfig, 
  onSearch, 
  showSortIcons = true, 
  color,
  narrow = false,
  searchColumn,
}) => {
  return (
    <Table color={color} style={narrow ? { maxWidth: '50%', width: '100%' } : undefined}>
      <Thead>
        <Tr>
          {columns.map((col) => (
            <Th key={`${col.key}-icons`} width={typeof col.width === 'string' ? col.width : col.width ? `${col.width}%` : undefined} bgColor={color || undefined} style={{ padding: '10px 10px 5px 10px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', width: '100%', height: '100%' }}>
                {onSearch && col.searchable !== false && (
                  <SearchHeaderIcon onClick={() => onSearch(col.key)} active={col.key === searchColumn} bgColor={color || DEFAULT_TABLE_COLOR} />
                )}
                {showSortIcons && onSort && col.sortable !== false && (
                  <SortIconsWrapper>
                    {sortConfig?.key === col.key ? (
                      sortConfig.direction === 'asc' ? (
                        <SortHeaderIcon direction="desc" onClick={() => onSort(col.key, 'desc' )} active={true} bgColor={color || DEFAULT_TABLE_COLOR} />
                      ) : (
                        <SortHeaderIcon direction="asc" onClick={() => onSort(col.key, 'asc')} active={true} bgColor={color || DEFAULT_TABLE_COLOR} />
                      )
                    ) : (
                      <SortHeaderIcon direction="asc" onClick={() => onSort(col.key, 'asc')} active={false} bgColor={color || DEFAULT_TABLE_COLOR} />
                    )}
                  </SortIconsWrapper>
                )}
              </div>
            </Th>
          ))}
        </Tr>
        <Tr>
          {columns.map((col) => (
            <Th key={`${col.key}-text`} width={typeof col.width === 'string' ? col.width : col.width ? `${col.width}%` : undefined} bgColor={color || undefined} style={{ borderTop: 'none', padding: '5px 10px 10px 10px' }}>
              <HeaderCenterContent>
                {col.headerRender ? col.headerRender() : <HeaderText>{col.displayName}</HeaderText>}
              </HeaderCenterContent>
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>{children}</Tbody>
    </Table>
  );
};

export default AppTable;
